import axios from "axios"

export default (data,fn) => {
    let formData = new FormData()
    for(let key in data){
        formData.append(key,data[key])
    }
    axios({
        url: '/api.php',
        method: 'post',
        data: formData,
        headers: {
            'product': 'TZ'
        },
    })
    .then((resp) => {
        fn(resp.data)
    })
} 


// WEBPACK FOOTER //
// ./src/pages/Helper/XHR.js